"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _DropdownMenu = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/DropdownMenu"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var roleDropdownTheme = {
  "DropdownMenuToggle": "RoleDropdownTheme__DropdownMenuToggle__3Dsts",
  "dropdownMenuToggle": "RoleDropdownTheme__DropdownMenuToggle__3Dsts",
  "DropdownMenuContent": "RoleDropdownTheme__DropdownMenuContent__2kxH8",
  "dropdownMenuContent": "RoleDropdownTheme__DropdownMenuContent__2kxH8",
  "headItem": "RoleDropdownTheme__headItem__1My6V",
  "DropdownMenuMenu": "RoleDropdownTheme__DropdownMenuMenu__s6ZoB",
  "dropdownMenuMenu": "RoleDropdownTheme__DropdownMenuMenu__s6ZoB",
  "DropdownMenu": "RoleDropdownTheme__DropdownMenu__3ZvQD",
  "dropdownMenu": "RoleDropdownTheme__DropdownMenu__3ZvQD",
  "DropdownMenuItem": "RoleDropdownTheme__DropdownMenuItem__4pwMb",
  "dropdownMenuItem": "RoleDropdownTheme__DropdownMenuItem__4pwMb",
  "list": "RoleDropdownTheme__list__2YzV2"
}; 
require('./RoleDropdownTheme.css');
var styles = {
  "label": "Role__label__3PO_2",
  "removable-user": "Role__removable-user__1TVYh",
  "removableUser": "Role__removable-user__1TVYh",
  "role-description": "Role__role-description__3oWud",
  "roleDescription": "Role__role-description__3oWud"
}; 
require('./Role.css');
function getLabel(role) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.role
  }, /*#__PURE__*/_react.default.createElement("div", null, role.label), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.roleDescription
  }, role.description));
}
var roles = function roles(config) {
  return config.roles.map(function (role) {
    return _objectSpread(_objectSpread({}, role), {}, {
      label: getLabel(role)
    });
  });
};
var getRoleLabelById = function getRoleLabelById(config, updatedRole) {
  if (!updatedRole) {
    return undefined;
  }
  var wantedRole = config.roles.find(function (role) {
    return role.id === updatedRole.id;
  });
  return wantedRole ? wantedRole.label : undefined;
};
var canChangeRole = function canChangeRole(_ref) {
  var isCurrentUser = _ref.isCurrentUser,
    identity = _ref.identity;
  return isCurrentUser || identity.isMarkedAsDeleted || identity.type === 'external' || identity.identityType === 'externalOrganization';
};
var Role = function Role(_ref2) {
  var identity = _ref2.identity,
    isCurrentUser = _ref2.isCurrentUser,
    onRoleChange = _ref2.onRoleChange;
  var config = (0, _exchangeReactHooks.useConfig)();
  return canChangeRole({
    isCurrentUser: isCurrentUser,
    identity: identity
  }) ? /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames2.default)(styles.label, (0, _defineProperty2.default)({}, styles.removableUser, !!identity.isMarkedAsDeleted))
  }, getRoleLabelById(config, identity.updatedRole) || identity.role.label) : /*#__PURE__*/_react.default.createElement(_DropdownMenu.default, {
    theme: roleDropdownTheme,
    options: roles(config),
    className: styles.drop,
    "aria-label": "Asset roles to be assigned",
    placeholder: "Role",
    valueKey: "id",
    labelKey: "label",
    value: identity.updatedRole && identity.updatedRole.id || identity.role.id,
    testId: "role-selector",
    onChange: function onChange(option) {
      return onRoleChange(identity, option.value);
    },
    alignment: "right"
  });
};
Role.propTypes = {
  identity: _propTypes.default.object.isRequired,
  isCurrentUser: _propTypes.default.bool,
  onRoleChange: _propTypes.default.func.isRequired
};
Role.defaultProps = {
  isCurrentUser: false
};
var _default = exports.default = Role;
//# sourceMappingURL=Role.js.map